import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { toast } from 'sonner';
import { redirectToSignIn } from './lib/api';
import { createQueryClient } from './lib/error-policy';
import { routeTree } from './routeTree.gen';
import './styles.css';

// The error policy (401, 409 revision_conflict, friendly toasts, read retries) lives in lib/error-policy.ts.
const queryClient = createQueryClient({
  signIn: redirectToSignIn,
  toastError: (message, description) => toast.error(message, description ? { description } : undefined),
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { silent?: boolean };
  }
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('The #root element is missing');
}
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
